import { ImSpinner2 } from 'react-icons/im';
import '../styles/sidebarSkeleton.css';

const SidebarSkeleton = () => {
  return (
    <div className="movyx-sidebar">
      <div className="sidebar-header">
        <div className="sidebar-skeleton-header">
          <div className="sidebar-skeleton-logo"></div>
          <div className="sidebar-skeleton-avatar"></div>
          <div className="sidebar-skeleton-username"></div>
        </div>
      </div>

      <nav className="sidebar-menu">
        {Array.from({ length: 6 }, (_, index) => (
          <div key={`skeleton-${index}`} className="sidebar-skeleton-item">
            <ImSpinner2 className="sidebar-skeleton-spinner" />
            <div className="sidebar-skeleton-text"></div>
          </div>
        ))}
      </nav>

      <div className="sidebar-footer">
        <div className="sidebar-skeleton-item">
          <ImSpinner2 className="sidebar-skeleton-spinner" />
          <div className="sidebar-skeleton-text"></div>
        </div>
      </div>
    </div>
  );
};

export default SidebarSkeleton;
